import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-15",
  "use": "menu-15-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"menu-15\"><defs><style>#menu-15 .cls-1{fill:none}</style></defs><title>资源 1</title><g id=\"menu-15_图层_2\" data-name=\"图层 2\"><g id=\"menu-15_图层_1-2\" data-name=\"图层 1\"><path id=\"menu-15_矩形_325\" data-name=\"矩形 325\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path d=\"M19.53 2h-15a.52.52 0 0 0-.53.51v2.86h6.2l.85 2h9V2.52a.51.51 0 0 0-.5-.52z\" /><path d=\"M20.8 20.84v-12h-9.51l-.47-1L9.94 6H3.2v14.8h17.6m.2 1.7H3a1.46 1.46 0 0 1-1.5-1.43V5.81A1.47 1.47 0 0 1 3 4.34h7.14a1.46 1.46 0 0 1 1.32.83l1 2H21a1.47 1.47 0 0 1 1.5 1.44v12.46a1.47 1.47 0 0 1-1.5 1.47z\" /><path d=\"M19.49 14.05h-5.11a.85.85 0 0 1 0-1.7h5.11a.85.85 0 0 1 0 1.7z\" id=\"menu-15_直线_1\" data-name=\"直线 1\" /><path d=\"M19.49 19.47h-9.37a.85.85 0 1 1 0-1.7h9.37a.85.85 0 0 1 0 1.7z\" id=\"menu-15_直线_2\" data-name=\"直线 2\" /><path d=\"M19.49 16.76h-3.57a.85.85 0 0 1 0-1.7h3.57a.85.85 0 1 1 0 1.7z\" id=\"menu-15_直线_3\" data-name=\"直线 3\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-15.svg
// module id = /ELe
// module chunks = 6